export { default as withKeyboardClose } from './withKeyboardClose.component';
